import { Button, notification } from "antd";
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { formFields } from '../../assets/data/survey/survey-form-field';
import EnhancedCameraModal from '../../components/CameraInstructionsModal/EnhancedCameraModal';
import PatientSurveyField from '../../components/PatientSurvey';
import { FormContainer, FormWrapper, Title } from '../../components/PatientSurvey/PatientSurvey.styles';
import useFormField from '../../hooks/useFormField';
import { createSurvey, submitSurveyWithToken } from "../../utils/api-lists/patient.api";
import { FullScreeen } from './widget/sharedPage.styles';


const PatientSurveySubmitShare = () => {
    const { t } = useTranslation("common");
    const location = useLocation();

    const [isSent, setIsSent] = useState(false);
    const [cameraVisible, setCameraVisible] = useState(false);
    const [mediaFiles, setMediaFiles] = useState([]); // Changed from images to mediaFiles

    const queryParams = new URLSearchParams(location.search);
    const patientId = queryParams.get('patientId');
    const doctorId = queryParams.get('doctorId');
    const token = queryParams.get('token');


    const initialValues = formFields.reduce((acc, field) => {
        acc[field.name] = field.type === "multi-select" || field.type === "creatable-multi-select" ? [] : "";
        return acc
    }, {})

    const validateForm = (formData) => {
        let errors = {};

        formFields.forEach((field) => {
            if (
                field.required &&
                (!formData[field.name] ||
                    (Array.isArray(formData[field.name]) &&
                        formData[field.name].length === 0))
            ) {
                errors[field.name] = `${field.label} is required`;
            }
        });

        return errors;
    };

    const handleAddMedia = (file) => {
        setMediaFiles(prev => [...prev, file]);
    };

    const handleRemoveMedia = (index) => {
        setMediaFiles(prev => prev.filter((_, i) => i !== index));
    };

    const isVideoFile = (file) => {
        return file.type.startsWith('video/');
    };

    const onSave = async () => {
        setIsSent(true);
        try {
            if (token) {
                const formData = new FormData();
                formData.append('survey_response', JSON.stringify(formDataState));
                mediaFiles.forEach((file, idx) => {
                    const fieldName = isVideoFile(file) ? `videos[${idx}]` : `images[${idx}]`;
                    formData.append(fieldName, file, file.name);
                });
                await submitSurveyWithToken(token, formData);
            } else {
                await createSurvey(patientId, doctorId, formDataState);
            }
           
            notification.success({
                message: t("success"),
                description: t("survey_submitted_successfully"),
                placement: "top",
                duration: 3
            });

        } catch (error) {
            console.error("Error submitting survey:", error);
            notification.error({
                message: t("error"),
                description: t("survey_submission_failed"),
                placement: "top",
                duration: 3
            });

            setIsSent(false);
        }
    };


    const {
        formData: formDataState,
        formErrors,
        handleInputChange,
        handleReactSelectChange,
        handleReactMultiSelectChange,
        handleSubmit,
    } = useFormField(initialValues, validateForm, formFields);


    return (
        <FullScreeen>
            <FormContainer>
                <FormWrapper>
                    <Title>{t("glacies_biome_questionare")}</Title>
                    {formFields.map((field) => {
                        return (
                            <PatientSurveyField
                                key={field.name}
                                name={field.name}
                                disabled={isSent}
                                field={field}
                                value={formDataState[field.name]}
                                error={formErrors[field.name]}
                                onChange={
                                    field.type === "multi-select" || field.type === "creatable-multi-select"
                                        ? handleReactMultiSelectChange
                                        : field.type === "select"
                                            ? handleReactSelectChange
                                            : handleInputChange
                                }
                            />
                        )
                    })}
                    {
                        !isSent &&
                        <Button type="primary" className="max-w-44 mt-5" onClick={(e) => handleSubmit(e, () => {
                            onSave();
                        })}>{t("submit")}</Button>
                    }
                    <Button onClick={() => setCameraVisible(true)} style={{ marginBottom: 16 }}>
                        Add Photo/Video
                    </Button>
                    <EnhancedCameraModal
                        visible={cameraVisible}
                        onClose={() => setCameraVisible(false)}
                        onCapture={handleAddMedia}
                        showInstructions={true}
                        mode="survey"
                    />
                    {mediaFiles.length > 0 && (
                        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', margin: '16px 0' }}>
                            {mediaFiles.map((file, idx) => (
                                <div key={idx} style={{ position: 'relative' }}>
                                    {isVideoFile(file) ? (
                                        <video
                                            src={URL.createObjectURL(file)}
                                            style={{
                                                width: 80,
                                                height: 80,
                                                objectFit: 'cover',
                                                borderRadius: 8,
                                                border: '2px solid #eee'
                                            }}
                                            muted
                                        />
                                    ) : (
                                        <img
                                            src={URL.createObjectURL(file)}
                                            alt={`survey-media-${idx}`}
                                            style={{
                                                width: 80,
                                                height: 80,
                                                objectFit: 'cover',
                                                borderRadius: 8,
                                                border: '2px solid #eee'
                                            }}
                                        />
                                    )}
                                    <Button size="small" danger style={{ position: 'absolute', top: 2, right: 2 }}
                                        onClick={() => handleRemoveMedia(idx)}>
                                        X
                                    </Button>
                                </div>
                            ))}
                        </div>
                    )}
                </FormWrapper>
            </FormContainer>
        </FullScreeen>
    );
}

export default PatientSurveySubmitShare;
